module.exports = __webpack_public_path__ + "img/icon-cellphone-purple.835de6e6.svg";